module.exports = {"tableConfig":{"columns":[{"header":"DATA DO REPASSE","type":"bold","width":"30%"},{"header":"VALOR (R$)","type":"bold","width":"25%"},{"header":"STATUS","type":"normal","width":"25%"},{"header":"Ver mais","type":"action","width":"20%"}]}}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/ec/DashboardResume/receipts/table/data.json
// module id = 2245
// module chunks = 0